import { connectBreadcrumb } from 'react-instantsearch-dom'

import Hit from 'components/Filters/types/Hit'
import Typography from 'components/UI/Typography/Typography'

import styles from './CustomBreadcrumb.module.css'

// Type missing in Algolia types
type BreadcrumbsProvided = {
  items: Hit[]
  refine: (value: string) => void
}

const CustomBreadcrumb = ({ items, refine }: BreadcrumbsProvided) => (
  <div className={styles.wrapper}>
    {[{ label: 'All', value: undefined }, ...items].map((item) => (
      <div
        key={item.label}
        className={styles.item}
        onClick={() => refine(item.value)}
        role="button"
        tabIndex={0}
      >
        <Typography.BodySmallBold>{item.label}</Typography.BodySmallBold>
        <span className={styles.arrow}>{'>'}</span>
      </div>
    ))}
  </div>
)

export default connectBreadcrumb(CustomBreadcrumb)
